import { useTranslation } from 'react-i18next'

import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { FurnitureOrderType } from 'sections/LKSection/modules/OrderModule/types'
import { Flex, Text } from 'components/uiKit'

type FurnitureOrderTextProps = {
  furnitureOrderType: FurnitureOrderType
  isMove: boolean
}

export const FurnitureOrderText = ({ furnitureOrderType, isMove }: FurnitureOrderTextProps) => {
  const { t } = useTranslation()

  const getKey = (key: string) => `${OrderKeys.orderItemPage}.${key}`

  return (
    <Flex vertical gap={16}>
      {isMove && (
        <>
          <Text>{t(getKey('Осталось подготовить пункт выдачи'))}</Text>
          <Text>{t(getKey('Поскольку это переезд'))}</Text>
          <Text>{t(getKey('После этого перейдите'))}</Text>
        </>
      )}

      {!isMove &&
        (furnitureOrderType === FurnitureOrderType.auto ? (
          <>
            <Flex vertical>
              <Text>
                {t(getKey('Осталось подготовить пункт выдачи'))} {t(getKey('Отправили вам в подарок оборудование'))}
              </Text>
              <Text>{t(getKey('Оборудование доставят в пункт выдачи'))}</Text>
            </Flex>

            <Text>{t(getKey('На данном этапе ваша задача'))}</Text>
          </>
        ) : (
          <>
            <Flex vertical>
              <Text>{t(getKey('Ваша заявка была одобрена'))}</Text>
              <Text>{t(getKey('Для этого'))}:</Text>
              <Text>- {t(getKey('Закажите и установите контроллер'))}</Text>
              <Text>- {t(getKey('Фирменную вывеску и панель кронштейн'))}</Text>
            </Flex>

            <Flex vertical>
              <Text>{t(getKey('Фирменная вывеска мини'))}</Text>
              <Text>{t(getKey('выплата компенсации за вывеску'))}</Text>
              <Text>{t(getKey('Оформить доставку вывески мини'))}</Text>
            </Flex>

            <Flex vertical>
              <Text>{t(getKey('Артикулы'))}:</Text>
              <Text>
                {t(getKey('Контроллер'))} — <Text copyable>211414522</Text>
              </Text>
              <Text>
                {t(getKey('Световой кронштейн'))} — <Text copyable>209248151</Text>
              </Text>
              <Text>
                {t(getKey('Световая белая мини-вывеска'))} — <Text copyable>221540808</Text>
              </Text>
              <Text>
                {t(getKey('Световая фиолетовая мини-вывеска'))} — <Text copyable>221540807</Text>
              </Text>
            </Flex>

            <Flex vertical>
              <Text>{t(getKey('На каждую позицию необходимо'))}</Text>
              <Text>{t(getKey('Формат вывески мини'))}</Text>
            </Flex>

            <Flex vertical>
              <Text>{t(getKey('Чтобы получить оборудование'))}:</Text>
              <Text>1. {t(getKey('Скопировать артикул позиции'))};</Text>
              <Text>2. {t(getKey('Перейти в веб-версию Wildberries'))};</Text>
              <Text>3. {t(getKey('Зайти в профиль под номером'))};</Text>
              <Text>4. {t(getKey('Вставить артикул в поиск'))};</Text>
              <Text>5. {t(getKey('Добавить в корзину позицию'))};</Text>
              <Text>6. {t(getKey('Изменить способ оплаты'))};</Text>
              <Text>7. {t(getKey('Выбрать удобный адрес'))};</Text>
              <Text>8. {t(getKey('Заказать товар в подарок'))}</Text>
              <Text>{t(getKey('В случае оформления заказа'))}</Text>
            </Flex>

            <Flex vertical>
              <Text>{t(getKey('После чего переходите к активации'))}</Text>
              <Text>{t(getKey('При активации ПВЗ не забудьте'))}</Text>
            </Flex>
          </>
        ))}
    </Flex>
  )
}
